module.exports = __webpack_public_path__ + "media/packs/images/flags/TP-31fb1df4af160fec1f809d9f487417a3.svg";